export enum ErrorType {
  GENERIC_ERROR = "GENERIC_ERROR",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  USER_COUNTRY_NOT_MACH = "USER_COUNTRY_NOT_MACH",
  RE_AUTHENTICATION_REQUIRED_BINDID = "RE_AUTHENTICATION_REQUIRED_BINDID",
}
